import * as React from 'react'

interface IPropTypes {
  label: string
  symbol: string
}

const Emoji = ({ label, symbol }: IPropTypes) => {
  return (
    <span
      className="emoji"
      role="img"
      aria-label={label ? label : ''}
      aria-hidden={label ? 'false' : 'true'}
    >
      {symbol}
    </span>
  )
}

export default Emoji
